import * as React from 'react'

function SvgCheckmarkCircle2(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className={'icon icon--checkmark-circle-2 ' + (props.classes ? props.classes : '')}
      {...props}
    >
      <path d="M7.98 1.333c.53.008 1.07.062 1.588.186.357.086.578.446.491.804-.086.358-.448.578-.804.492-.414-.1-.853-.142-1.27-.148-1.425.004-2.763.562-3.767 1.572-1.005 1.01-1.555 2.352-1.551 3.776.004 1.425.562 2.762 1.572 3.767 1.007 1 2.342 1.551 3.761 1.551h.015c1.425-.004 2.763-.562 3.767-1.572 1.005-1.01 1.555-2.352 1.551-3.776 0-.368.297-.668.665-.669.37 0 .668.297.669.665.005 1.78-.684 3.457-1.94 4.72-1.255 1.262-2.927 1.96-4.708 1.966H8c-1.774 0-3.443-.688-4.7-1.94C2.036 11.472 1.338 9.8 1.332 8.02c-.005-1.78.684-3.457 1.94-4.72C4.528 2.037 6.2 1.34 7.98 1.333zm4.185 2.894c.243-.275.664-.304.941-.062.277.242.305.664.062.941l-4.667 5.333c-.121.139-.294.221-.479.228H8c-.177 0-.346-.07-.471-.196l-2-2c-.261-.26-.261-.682 0-.942.26-.261.682-.261.942 0l1.496 1.496z" />
    </svg>
  )
}

export default SvgCheckmarkCircle2
